import Script from "next/script";
import { config } from "canbook-data/config";
import { usePageState } from "./index-state";
import { Inter } from "next/font/google";
import { RECAPTCHA_API_URL } from "canbook-data/util/urls";
import ThreeDotLoader from "canbook-style/ui/loader/three-dot";
import Head from "next/head";
import {
  LoginMethodComponent,
  PhoneComponent,
  EmailComponent,
  OtpComponent,
  ProfileComponent,
} from "./components";

const inter = Inter({ subsets: ["latin"] });

export default function Login() {
  const section1 = [
    "/images/login/1.png",
    "/images/login/2.png",
    "/images/login/3.png",
    "/images/login/4.png",
  ];
  const section2 = [
    "/images/login/5.png",
    "/images/login/6.png",
    "/images/login/7.png",
    "/images/login/8.png",
    "/images/login/9.png",
  ];
  const section3 = [
    "/images/login/9.png",
    "/images/login/4.png",
    "/images/login/1.png",
    "/images/login/5.png",
  ];
  const section4 = [
    "/images/login/8.png",
    "/images/login/2.png",
    "/images/login/3.png",
    "/images/login/6.png",
    "/images/login/7.png",
  ];
  const section5 = [
    "/images/login/7.png",
    "/images/login/9.png",
    "/images/login/4.png",
    "/images/login/1.png",
  ];

  const images = [section1, section2, section3, section4, section5];

  const {
    isLoginMethodShow,
    isPhoneShow,
    isEmailShow,
    isOtpShow,
    isProfileShow,
    loginMethodCallback,
    phoneCallback,
    emailCallback,
    otpCallback,
    profileCallback,
    userId,
    phone,
    email,
    verificationId,
    checkingAuth,
    showPhoneScreen,
    showEmailScreen,
  } = usePageState();

  if (checkingAuth) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <ThreeDotLoader />
      </div>
    );
  }

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <section className={`h-screen w-full lg:flex ${inter.className}`}>
        <Script src={RECAPTCHA_API_URL + config.RECAPTCHA_SITE_KEY} />
        <div className="hidden lg:w-1/2 xl:w-2/3 h-full overflow-hidden lg:flex flex-col gap-1.5">
          {images.map((section, index) => (
            <div
              key={"login-side-img-section-" + index}
              className={`flex gap-1.5 h-[20%] ${
                index % 2 == 0 ? "" : "-ml-40"
              }`}
            >
              {section.map((img, index) => (
                <img
                  src={img}
                  alt={"Image-" + index}
                  key={"login-side-img-" + index}
                  className="h-full w-full object-cover"
                />
              ))}
            </div>
          ))}
        </div>
        {isLoginMethodShow && (
          <LoginMethodComponent callback={loginMethodCallback} />
        )}
        {isPhoneShow && (
          <PhoneComponent
            phoneNumber={phone}
            callback={phoneCallback}
            onSwitchToEmail={showEmailScreen}
          />
        )}
        {isEmailShow && (
          <EmailComponent
            emailAddress={email}
            callback={emailCallback}
            onSwitchToPhone={showPhoneScreen}
          />
        )}
        {isOtpShow && (
          <OtpComponent
            phone={phone}
            email={email}
            id={verificationId}
            callback={otpCallback}
          />
        )}
        {isProfileShow && (
          <ProfileComponent
            userId={userId}
            phone={phone}
            email={email}
            callback={profileCallback}
          />
        )}
      </section>
    </>
  );
}
